var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V6C12.75 6.41421 12.4142 6.75 12 6.75C11.5858 6.75 11.25 6.41421 11.25 6V2C11.25 1.58579 11.5858 1.25 12 1.25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.25C12.4142 17.25 12.75 17.5858 12.75 18V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V18C11.25 17.5858 11.5858 17.25 12 17.25Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39985 4.39985C4.69274 4.10695 5.16761 4.10695 5.46051 4.39985L8.29051 7.22985C8.5834 7.52274 8.5834 7.99761 8.29051 8.29051C7.99761 8.5834 7.52274 8.5834 7.22985 8.29051L4.39985 5.46051C4.10695 5.16761 4.10695 4.69274 4.39985 4.39985Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7099 15.7099C16.0028 15.417 16.4777 15.417 16.7706 15.7099L19.6006 18.5399C19.8935 18.8328 19.8935 19.3077 19.6006 19.6006C19.3077 19.8935 18.8328 19.8935 18.5399 19.6006L15.7099 16.7706C15.417 16.4777 15.417 16.0028 15.7099 15.7099Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 12C1.25 11.5858 1.58579 11.25 2 11.25H6C6.41421 11.25 6.75 11.5858 6.75 12C6.75 12.4142 6.41421 12.75 6 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 12C17.25 11.5858 17.5858 11.25 18 11.25H22C22.4142 11.25 22.75 11.5858 22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H18C17.5858 12.75 17.25 12.4142 17.25 12Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29051 15.7099C8.5834 16.0028 8.5834 16.4777 8.29051 16.7706L5.46051 19.6006C5.16761 19.8935 4.69274 19.8935 4.39985 19.6006C4.10695 19.3077 4.10695 18.8328 4.39985 18.5399L7.22985 15.7099C7.52274 15.417 7.99761 15.417 8.29051 15.7099Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6006 4.39985C19.8935 4.69274 19.8935 5.16761 19.6006 5.46051L16.7706 8.29051C16.4777 8.5834 16.0028 8.5834 15.7099 8.29051C15.417 7.99761 15.417 7.52274 15.7099 7.22985L18.5399 4.39985C18.8328 4.10695 19.3077 4.10695 19.6006 4.39985Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoder);
export default __webpack_public_path__ + "static/media/Loder.32e477191d45d387b2878930805a2db9.svg";
export { ForwardRef as ReactComponent };